import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
// Component
import Card from '../../layout/sui/card/Card';

const propTypes = {
  locale: PropTypes.string,
  exhibitor: PropTypes.object.isRequired,
};

const Exhibitor = (props) => {
  const { id, tradeName, companyName, booth } = props.exhibitor;

  const label = {
    extraClasses: 'right ribbon blue',
    text: (
      <FormattedMessage
        id="booth"
        description="Booth number"
        default="Booth number"
        values="+ Info"
      />
    ),
  };

  const contents = [
    {
      header: companyName,
      // meta: tradeName,
      label,
    },
  ];

  let url;

  switch (props.locale) {
    case 'pt':
      url = '/pt/expositores/';
      break;
    case 'es':
      url = '/es/expositores/';
      break;
    default:
      url = '/en/exhibitors/';
  }

  const link = `${url}${id}`;


  return (
    <Card
      id={props.exhibitor.id}
      contents={contents}
      link={link}
    />
  );
};

Exhibitor.propTypes = propTypes;

export default Exhibitor;



/** WEBPACK FOOTER **
 ** ./src/components/screens/exhibitors/Exhibitor.js
 **/